import modelsArrayToMapById from '../../shared/services/modelsArrayToMapById';
import UserStatus from '../UserStatus';
import {fromJS, Map} from 'immutable';
import * as actionTypes from '../actions/types';

const initialState = new Map();

export default function (state = initialState, action) {
  switch (action.type) {
    case actionTypes.LOAD_USERS_LIST_FULFILLED:
      return modelsArrayToMapById(action.payload.data);

    case actionTypes.DISABLE_USER_FULFILLED:
      return state.setIn([action.payload.data.userId, 'status'], UserStatus.disabled);

    case actionTypes.ENABLE_USER_FULFILLED:
      return state.setIn([action.payload.data.userId, 'status'], UserStatus.enabled);

    case actionTypes.UPDATE_USER_FULFILLED:
      return state.set(action.payload.data.id, fromJS(action.payload.data));

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./app/features/users/reducers/list.js